<template>
  <div>
    <b-container>
      <router-view />
    </b-container>
    <footer class="footer">
      <b-container>
        <hr />
        <span class="text-muted">
          <b-row>
            <b-col cols="9">
              <span>
                This website provides access to data from the Office of Faculty
                Development & Instructional Technology (OFDIT). For assistance
                please contact OFDIT.
                <b-link href="mailto:ofdit@sps.cuny.edu"
                  ><b-icon icon="envelope"></b-icon
                ></b-link>
              </span>
            </b-col>
            <b-col cols="3">
              <span v-if="this.$store.state.courseDev.user.currentUser">
                <strong>User:</strong>
                {{ this.$store.state.courseDev.user.currentUser.full_name }}
                <br />
                <strong>Program:</strong>
                {{ this.$store.state.courseDev.user.currentUser.program }}
              </span>
            </b-col>
          </b-row>
        </span>
      </b-container>
    </footer>
  </div>
</template>
<script>
  export default {
    name: 'App'
  }
</script>
<style>
  @import url('https://fonts.googleapis.com/css?family=Fira+Sans:600&display=swap');

  html {
    position: relative;
    min-height: 100%;
  }

  body {
    margin-bottom: 100px;
    background-color: #f4f3f3;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Fira Sans';
    font-weight: 600;
  }

  td {
    white-space: pre-wrap;
  }

  .footer {
    margin-top: 20px;
    height: 80px;
    width: 100%;
    bottom: 0;
    position: absolute;
    font-size: 95%;
  }

  .navbar {
    box-shadow: 0em 0.25em 0.25em #888888;
  }

  .card-title {
    margin-bottom: 0.15em;
  }
</style>
